import type { UserMiniEntity } from '@/features/user/domain/entities/UserMiniEntity'
import type { SpinWheelTranslationEntity } from './SpinWheelTranslationEntity'
import type { PrizeMiniEntity } from '@/features/prize/domain/entities/PrizeMiniEntity'
import type { BranchMiniEntity } from '@/features/branch/domain/entities/BranchMiniEntity'
import type { SpinWheelRegionEntity } from './SpinWheelRegionEntity'

export class CreateUpdateSpinWheelEntity {
  translations?: Array<SpinWheelTranslationEntity> | null
  validFrom?: string
  validTo?: string
  minOrdersCount?: number
  prizes?: Array<PrizeMiniEntity> | null
  priority?: number
  users?: Array<UserMiniEntity> | null
  isPrimary?: boolean
  branchs?: Array<BranchMiniEntity> | null
  spinWheelRegions?: Array<SpinWheelRegionEntity> | null
}
